import React from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { TalentDTO, useGetTalentById } from '@/api/generated';
import EntityLayout from '@/views/EntityLayout';
import TalentEditInfoModal from '@/views/TalentEditInfoModal/TalentEditInfoModal';
import TalentHeader from '@/views/TalentHeader';
import TalentProcessesList from '@/views/TalentProcessesList';

const Talent = () => {
  const { talentId, testSessionId } = useParams<{ talentId: string; testSessionId?: string }>();
  const { data: talent } = useGetTalentById<TalentDTO>(talentId!, { query: { enabled: !!talentId } });

  return (
    <>
      <EntityLayout header={<TalentHeader talent={talent} />} localStorageKey={LAYOUT_KEY}>
        {testSessionId ? <Outlet /> : <TalentProcessesList />}
      </EntityLayout>
      <TalentEditInfoModal />
    </>
  );
};

const LAYOUT_KEY = 'talent';

export default Talent;
